export type TStoryLocale = 'en' | 'da' | 'fi' | 'it' | 'sv';

export const DEFAULT_STORY_LOCALE: TStoryLocale = 'en';

type TStoryLocaleOption = {
  code: TStoryLocale;
  label: string;
  flag: string;
};

export const STORY_LOCALES: TStoryLocaleOption[] = [
  { code: 'en', label: 'English', flag: '🇬🇧' },
  { code: 'da', label: 'Danish', flag: '🇩🇰' },
  { code: 'fi', label: 'Finnish', flag: '🇫🇮' },
  { code: 'it', label: 'Italian', flag: '🇮🇹' },
  { code: 'sv', label: 'Swedish', flag: '🇸🇪' },
];

export const STORY_LOCALE_CODES: TStoryLocale[] = STORY_LOCALES.map((locale) => locale.code);
